import React from 'react'
import { useResetDependentFields } from './useResetDependentFields'

const ACRForm = ({ formik }) => {
  // Reset first representation dependent fields if not 'yes'
  useResetDependentFields(
    formik,
    'representationFiled',
    ['yes'],
    ['representationStatus', 'decisionDate', 'decisionOutcome']
  )

  useResetDependentFields(
    formik,
    'representationStatus',
    ['pending'],
    ['decisionDate', 'decisionOutcome']
  )

  useResetDependentFields(formik, 'decisionOutcome', ['dismissed'], ['remarks'])

  useResetDependentFields(
    formik,
    'representationFiledSecondary',
    ['yes'],
    [
      'representationStatusSecondary',
      'decisionDateSecondary',
      'decisionOutcomeSecondary',
    ]
  )

  useResetDependentFields(
    formik,
    'representationStatusSecondary',
    ['pending'],
    ['decisionDateSecondary', 'decisionOutcomeSecondary']
  )
  useResetDependentFields(
    formik,
    'decisionOutcomeSecondary',
    ['dismissed'],
    ['remarksSecondary']
  )

  const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
  ]
  const representationStatusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'decided', label: 'Decided' },
  ]

  const decisionOutcomeOptions = [
    { value: 'dismissed', label: 'Dismissed' },
    {
      value: 'integrityExpunged',
      label: 'Adverse entry in integrity column expunged',
    },
    {
      value: 'reliabilityExpunged',
      label: 'Adverse entry in reliability column expunged',
    },
    {
      value: 'integrityAndReliabilityExpunged',
      label: 'Adverse entry in  integrity and reliability column expunged',
    },
  ]

  return (
    <>
      {/* Assessment Period */}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Assessment Period From <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <input
            type="date"
            className="form-control"
            name="assessmentFrom"
            value={formik.values.assessmentFrom}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            onClick={(e) => e.target.showPicker && e.target.showPicker()}
          />
          {formik.touched.assessmentFrom && formik.errors.assessmentFrom && (
            <div className="invalid-feedback d-block">
              {formik.errors.assessmentFrom}
            </div>
          )}
        </div>
      </div>

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Assessment Period To <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <input
            type="date"
            className="form-control"
            name="assessmentTo"
            value={formik.values.assessmentTo}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            onClick={(e) => e.target.showPicker && e.target.showPicker()}
          />
          {formik.touched.assessmentTo && formik.errors.assessmentTo && (
            <div className="invalid-feedback d-block">
              {formik.errors.assessmentTo}
            </div>
          )}
        </div>
      </div>

      {/* Integrity Doubtful */}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Integrity Doubtful? <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="integrityDoubtful"
            value={formik.values.integrityDoubtful}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select</option>
            {yesNoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched.integrityDoubtful &&
            formik.errors.integrityDoubtful && (
              <div className="invalid-feedback d-block">
                {formik.errors.integrityDoubtful}
              </div>
            )}
        </div>
      </div>

      {/* Reliability Doubtful */}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Reliability Doubtful? <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="reliabilityDoubtful"
            value={formik.values.reliabilityDoubtful}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select</option>
            {yesNoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched.reliabilityDoubtful &&
            formik.errors.reliabilityDoubtful && (
              <div className="invalid-feedback d-block">
                {formik.errors.reliabilityDoubtful}
              </div>
            )}
        </div>
      </div>

      {/* Representation Filed */}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          First Representation Filed <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="representationFiled"
            value={formik.values.representationFiled}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select</option>
            {yesNoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched.representationFiled &&
            formik.errors.representationFiled && (
              <div className="invalid-feedback d-block">
                {formik.errors.representationFiled}
              </div>
            )}
        </div>
      </div>

      {/* Show fields only if representation filed */}
      {formik.values.representationFiled === 'yes' && (
        <>
          {/* Status */}
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">Status</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="representationStatus"
                value={formik.values.representationStatus}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select</option>
                {representationStatusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>

              {formik.touched.representationStatus &&
                formik.errors.representationStatus && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.representationStatus}
                  </div>
                )}
            </div>
          </div>

          {/* Decision flow */}
          {formik.values.representationStatus === 'decided' && (
            <>
              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">Decision Date</label>
                <div className="col-sm-8">
                  <input
                    type="date"
                    className="form-control"
                    name="decisionDate"
                    value={formik.values.decisionDate}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                  />
                  {formik.touched.decisionDate &&
                    formik.errors.decisionDate && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.decisionDate}
                      </div>
                    )}
                </div>
              </div>

              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                  Outcome of Representation
                </label>
                <div className="col-sm-8">
                  <select
                    className="form-control"
                    name="decisionOutcome"
                    value={formik.values.decisionOutcome}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select</option>
                    {decisionOutcomeOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                  {formik.touched.decisionOutcome &&
                    formik.errors.decisionOutcome && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.decisionOutcome}
                      </div>
                    )}
                </div>
              </div>


            </>
          )}
        </>
      )}

      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Second Representation Filed <span style={{ color: 'red' }}>*</span>
        </label>
        <div className="col-sm-8">
          <select
            className="form-control"
            name="representationFiledSecondary"
            value={formik.values.representationFiledSecondary}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select</option>
            {yesNoOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
          {formik.touched.representationFiledSecondary &&
            formik.errors.representationFiledSecondary && (
              <div className="invalid-feedback d-block">
                {formik.errors.representationFiledSecondary}
              </div>
            )}
        </div>
      </div>

      {formik.values.representationFiledSecondary === 'yes' && (
        <>
          {/* Status */}
          <div className="form-group row mb-3">
            <label className="col-sm-4 col-form-label">Status</label>
            <div className="col-sm-8">
              <select
                className="form-control"
                name="representationStatusSecondary"
                value={formik.values.representationStatusSecondary}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <option value="">Select</option>
                {representationStatusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>

              {formik.touched.representationStatusSecondary &&
                formik.errors.representationStatusSecondary && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.representationStatusSecondary}
                  </div>
                )}
            </div>
          </div>

          {/* Decision flow */}
          {formik.values.representationStatusSecondary === 'decided' && (
            <>
              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">Decision Date</label>
                <div className="col-sm-8">
                  <input
                    type="date"
                    className="form-control"
                    name="decisionDateSecondary"
                    value={formik.values.decisionDateSecondary}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    onClick={(e) =>
                      e.target.showPicker && e.target.showPicker()
                    }
                  />
                  {formik.touched.decisionDateSecondary &&
                    formik.errors.decisionDateSecondary && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.decisionDateSecondary}
                      </div>
                    )}
                </div>
              </div>

              <div className="form-group row mb-3">
                <label className="col-sm-4 col-form-label">
                  Outcome of Representation
                </label>
                <div className="col-sm-8">
                  <select
                    className="form-control"
                    name="decisionOutcomeSecondary"
                    value={formik.values.decisionOutcomeSecondary}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select</option>
                    {decisionOutcomeOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                  {formik.touched.decisionOutcomeSecondary &&
                    formik.errors.decisionOutcomeSecondary && (
                      <div className="invalid-feedback d-block">
                        {formik.errors.decisionOutcomeSecondary}
                      </div>
                    )}
                </div>
              </div>


            </>
          )}
        </>
      )}
      <div className="form-group row mb-3">
        <label className="col-sm-4 col-form-label">
          Remarks
        </label>
        <div className="col-sm-8">
          <textarea
            className="form-control"
            name="remarks"
            value={formik.values.remarks}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.remarks && formik.errors.remarks && (
            <div className="invalid-feedback d-block">
              {formik.errors.remarks}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default ACRForm
